/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Previous Icon.
 */
export const PreviousIcon = (props: IconProps) => {
  const {iconSize, iconColor = '#828282'} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 29 28' fill='white' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8.74996 21V7H6.99996V21H8.74996ZM22.1666 21V7L12.075 14L22.1666 21Z' fill={iconColor}/>
    </svg>
  );
};
